import axios from "axios";
import { Button, DataGrid, LoadPanel } from "devextreme-react";
import AuthFileUploader from "../../../../common/AuthFileUploader";
import {
  Column,
  Editing,
  Export,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Item,
  Paging,
  Popup,
  Scrolling,
  Selection,
  Sorting,
  Texts,
  Toolbar,
  ToolbarItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notifyMsg } from "../../../../common/notify";
import ClinicalSiteForm from "./ClinicalSiteForm";
import { init, updateAll } from "./Redux/clinicalSite";

import "./index.css";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import SiteList from "./SiteList";

export default function ClinicalSiteInfo(props) {
  const { sales, fullScreen, setFullScreen } = props;

  const clinicalSite = useSelector((state) => state.clinicalSite);
  const userInfo = useSelector((state) => state.userInfo);

  const siteDropDownBoxRef = useRef(null);
  const formClinicalSiteRef = useRef(null);
  const clinicalSiteInfoGridRef = useRef(null);

  const dispatch = useDispatch();

  const [clinicalSitePopupVisible, setClinicalSitePopupVisible] =
    useState(false);
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const [siteListPopupVisible, setSiteListPopupVisible] = useState(false);
  const [dataSource, setDataSource] = useState();
  useEffect(() => {
    if (sales.contrNo) {
      setDataSource(
        new CustomStore({
          key: ["contrNo", "siteNo"],
          load: async () => {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/${sales.contrNo}`
            );

            return result.data;
          },
          insert: async (values) => {
            await axios
              .post(
                `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/${sales.contrNo}/${values.siteNo}`,
                values
              )
              .catch(function (error) {
                if (error) {
                  notifyMsg(
                    "에러가 발생했습니다. 관리자에게 문의해주세요.",
                    "error"
                  );
                }
              });
          },
          update: async (key, values) => {
            await axios.put(
              // `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/${sales.contrNo}/${key}`,
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/${key.contrNo}/${key.siteNo}`,
              values
            );
          },
          remove: async (key) => {
            await axios
              .delete(
                // `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/${sales.contrNo}/${key}`
                `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/${key.contrNo}/${key.siteNo}`
              )
              .catch(function (error) {
                if (error) {
                  console.error("error", error);

                  notifyMsg(
                    "에러가 발생했습니다. 관리자에게 문의해주세요",
                    "error"
                  );
                }
              });
          },
        })
      );
    }
  }, [sales.contrNo]);

  const onInitNewRow = () => {
    dispatch(init());

    setClinicalSitePopupVisible(true);
  };

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
        action: "update",
        // comment: null,
      })
    );

    setClinicalSitePopupVisible(true);
  };

  const contentRender = useCallback(() => {
    return (
      <ClinicalSiteForm
        clinicalSite={clinicalSite}
        siteDropDownBoxRef={siteDropDownBoxRef}
        formClinicalSiteRef={formClinicalSiteRef}
        contrNo={sales.contrNo}
      />
    );
  }, [clinicalSite]);

  const onSaveClick = useCallback(() => {
    let valid = true;

    // if (!clinicalSite.LAB_SEQ) {
    if (!clinicalSite.ykiho) {
      siteDropDownBoxRef.current.instance.option("validationStatus", "invalid");

      valid = false;
    }

    if (valid && formClinicalSiteRef.current.instance.validate().isValid) {
      setClinicalSitePopupVisible(false);

      if (clinicalSite.action == "insert") {
        clinicalSiteInfoGridRef.current.instance
          .getDataSource()
          .store()
          .insert(clinicalSite)
          .then(() => {
            clinicalSiteInfoGridRef.current.instance.refresh();
          });
      } else {
        // const updateValues = {};

        // for (const key of clinicalSite.updateFields) {
        //   if (clinicalSite.hasOwnProperty(key)) {
        //     updateValues[key] = clinicalSite[key];
        //   }
        // }

        // console.debug("updateValues", updateValues);

        clinicalSiteInfoGridRef.current.instance
          .getDataSource()
          .store()
          .update(
            { contrNo: clinicalSite.contrNo, siteNo: clinicalSite.siteNo },
            clinicalSite
          )
          .then(() => {
            clinicalSiteInfoGridRef.current.instance.refresh();
          });
      }
    }
  }, [clinicalSite]);

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#E2EFDA";
    }
  };

  const onExporting = (e) => {
    // const groupedColumns = e.component
    //   .getVisibleColumns()
    //   .filter((c) => c.groupIndex > -1);
    // console.debug("groupedColumns", groupedColumns);
    // if (groupedColumns.length > 0) {
    //   notifyMsg("Ungroup All.", "error");
    //   e.cancel = true;
    //   return;
    // }

    clinicalSiteInfoGridRef.current.instance.clearFilter();

    e.component.beginUpdate();
    e.component.columnOption("contrNo", "visible", true);
    // e.component.columnOption("LAB_SEQ", "visible", true);
    e.component.columnOption("ykiho", "visible", true);

    const workbook = new Workbook();

    workbook.creator = "BeTree";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Clinical Site Info.");

    worksheet.properties.defaultRowHeight = 13.5;

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        excelCell.font = {
          size: 10,
        };

        excelCell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        if (gridCell.rowType == "data") {
          // if (gridCell.column.dataField == "LAB_SEQ") {
          switch (gridCell.column.dataField) {
            case "ykiho":
            case "contrNo":
            case "siteNo":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FBFBFBF" },
              };
              break;
          }
        } else if (gridCell.rowType == "header") {
          excelCell.font = {
            bold: true,
            size: 10,
          };
          excelCell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FA9D08E",
            },
          };

          switch (gridCell.column.dataField) {
            case "contrNo":
              worksheet.getColumn(excelCell.col).width = 15;
              break;
            case "siteNo":
              worksheet.getColumn(excelCell.col).width = 7;
              break;
            // case "LAB_SEQ":
            case "ykiho":
            case "yadmNm":
              worksheet.getColumn(excelCell.col).width = 70;
              break;
            default:
              worksheet.getColumn(excelCell.col).width = 15;
              break;
          }
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          `Clinical Site Info_${sales.contrNo}.xlsx`
        );
      });

      e.component.columnOption("contrNo", "visible", false);
      // e.component.columnOption("LAB_SEQ", "visible", false);
      e.component.columnOption("ykiho", "visible", false);

      e.component.endUpdate();

      notifyMsg("Clinical Site Info 파일이 다운로드 되었습니다.", "success");
    });
  };

  const onUploadStarted = (e) => {
    setLoadPanelVisible(true);
  };

  const onUploaded = (e) => {
    setLoadPanelVisible(false);

    notifyMsg("Clinical Site Info 파일이 업로드되었습니다.", "success");

    clinicalSiteInfoGridRef.current.instance.refresh();
  };

  const onUploadError = (e) => {
    setLoadPanelVisible(false);

    if (e.error.response) {
      notifyMsg(JSON.parse(e.error.response).error.Message, "error");
    } else {
      notifyMsg("에러가 발생했습니다. 관리자에게 문의해주세요.", "error");
    }
  };

  const onHidingLoadPanel = () => {
    setLoadPanelVisible(false);
  };

  const onClick = () => {
    setSiteListPopupVisible(true);
  };

  const onMinMaxIconClick = () => {
    setFullScreen(!fullScreen);
  };

  return (
    <>
      <DataGrid
        id="clinicalSiteInfoGrid"
        ref={clinicalSiteInfoGridRef}
        dataSource={dataSource}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        rowAlternationEnabled={true}
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        width={"100%"}
        height={"auto"}
        repaintChangesOnly={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        onInitNewRow={onInitNewRow}
        onEditingStart={onEditingStart}
        onCellPrepared={onCellPrepared}
        onExporting={onExporting}
      >
        {/* <GroupPanel visible={true} /> */}
        {/* <SearchPanel visible={true} highlightCaseSensitive={true} width={240} /> */}
        {/* <Grouping autoExpandAll={true} contextMenuEnabled={true} /> */}
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
          showScrollbar={"always"}
        />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Paging enabled={false} />
        <Sorting mode={"multiple"} />
        <Selection mode={"single"} />

        <Export enabled={true} />

        <Editing
          refreshMode={"reshape"}
          mode={"popup"}
          allowAdding={true}
          allowUpdating={true}
          allowDeleting={true}
        >
          <Texts
            confirmDeleteMessage={
              "Are you sure want to delete this clinical site?"
            }
          />
          <Popup
            visible={clinicalSitePopupVisible}
            showTitle={true}
            title={
              clinicalSite.action == "insert"
                ? "Create a Site"
                : "Edit the Site"
            }
            height={"auto"}
            showCloseButton={true}
            contentRender={contentRender}
          >
            <ToolbarItem
              widget={"dxButton"}
              toolbar={"top"}
              location={"after"}
              options={{
                icon: "save",
                type: "normal",
                stylingMode: "contained",
                onClick: onSaveClick,
              }}
            />
          </Popup>
        </Editing>

        <Column
          dataField={"contrNo"}
          caption={"Contract No."}
          visible={false}
        />
        <Column dataField={"siteNo"} caption={"Site No."} dataType={"string"} />
        {/* <Column
          dataField={"LAB_NAME"}
          caption={"Site Name"}
          dataType={"string"}
        /> */}
        <Column
          dataField={"yadmNm"}
          caption={"Site Name"}
          dataType={"string"}
        />
        {/* <Column dataField={"LAB_SEQ"} caption={"LAB SEQ"} visible={false} /> */}
        <Column dataField={"ykiho"} caption={"ykiho"} visible={false} />
        <Column
          dataField={"INSPCT_MANAGER_NAME"}
          caption={"PI Name"}
          dataType={"string"}
        />
        <Column dataField={"SIDO"} caption={"Location"} dataType={"string"} />
        <Column dataField={"comment"} caption={"Comment"} dataType={"string"} />

        <Toolbar>
          <Item location={"before"} name={"groupPanel"} />
          <Item location={"before"}>
            <div className="file-uploader-block">
              <AuthFileUploader
                id="clinicalSiteInfoFileUploader"
                width={500}
                uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo?employeeNo=${userInfo.employeeNo}`}
                accept=".xlsx"
                allowedFileExtensions={[".xlsx"]}
                showFileList={false}
                onUploadStarted={onUploadStarted}
                onUploaded={onUploaded}
                onUploadError={onUploadError}
              />
            </div>
          </Item>
          <Item location={"after"}>
            <Button
              text="Site List"
              onClick={onClick}
              stylingMode="contained"
              type="success"
            />
          </Item>
          <Item location={"after"} name={"addRowButton"} />
          <Item location={"after"} name={"exportButton"} />
          <Item location={"after"}>
            <Button
              onClick={onMinMaxIconClick}
              icon={
                fullScreen ? `fa-solid fa-minimize` : `fa-solid fa-maximize`
              }
            />
          </Item>
        </Toolbar>
      </DataGrid>
      <LoadPanel
        shadingColor="rgba(0, 0, 0, 0.4)"
        position={{
          of: "#clinicalSiteInfoGrid",
        }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        onHiding={onHidingLoadPanel}
      />
      <SiteList
        siteListPopupVisible={siteListPopupVisible}
        setSiteListPopupVisible={setSiteListPopupVisible}
      />
    </>
  );
}
